import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { SecondaryColors, TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $stat': {
      color: TextColors.dark,
    },
    '& $standard': {
      color: TextColors.dark,
    },
    '& $blue': {
      color: SecondaryColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    '& $stat': {
      color: TextColors.light,
    },
    '& $standard': {
      color: TextColors.light,
    },
    '& $blue': {
      color: SecondaryColors.main,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    pretitle: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },

    richText: {
      ...typography.body1,
    },

    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      width: '100%',

      '&': {
        [muiTheme.breakpoints.up('md')]: {
          display: 'flex',
        },
      },
    },

    stat: {
      marginBottom: '24px',

      '&:last-child': {
        marginBottom: 0,
      },
    },

    stats: {},
    summaryText: {
      '& div:not(:first-child)': {
        marginTop: '24px',
      },
    },
    superHeading: {
      '&.MuiTypography-root': {
        marginTop: muiTheme.spacing(4),
        marginBottom: muiTheme.spacing(2),

        [muiTheme.breakpoints.up('md')]: {
          marginTop: 0,
          marginBottom: muiTheme.spacing(2),
        },
      },
    },

    standard: {},
    blue: {},
  }),
  { name: 'GenSolutionSummary' },
);

export default useStyles;
